import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, NavLink } from 'react-router-dom';

import NavBarWrapper from './NavBar.style';
import iconUser from '../../assets/icons/icon-user.svg';
import iconNoti from '../../assets/icons/icon-notification.svg';
import { Menu } from '../ui';
import type { NavBarProps, NavBarState } from './NavBar.types';
import invoiceActions from '../../ducks/invoice/actions';
import ImpersonatingFlag from '../ImpersonatingFlag';

import NotificationItem from '../NotificationItem';

class NavBar extends Component<NavBarProps, NavBarState> {
  constructor(props) {
    super(props);
    this.state = {
      showMenu: false,
      showUserMenu: false,
    };
    this.menuList = React.createRef();
  }

  componentDidMount() {
    const { getNotifications, isAdmin, user, hasAutomatedPayments } = this.props;

    if(!isAdmin && user?.isProvider) {
      getNotifications(user.rut);
    }
  }

  onNotificationsClick(event) {
    event.stopPropagation();
    const { showMenu } = this.state;
    this.setState({ showMenu: !showMenu });
  };

  onUserNameClick(event) {
    event.stopPropagation();
    const { showUserMenu } = this.state;
    this.setState({ showUserMenu: !showUserMenu });
  };

  onNotificationItemClick(item) {
    const { updateNotification, notifications } = this.props;
    updateNotification(notifications[item].providerRut, notifications[item].orderId, notifications[item].invoiceId);
  };

  onAllNotificationItemClick() {
    const { updateAllNotification, notificationsNew, user, getNotifications } = this.props;

    for(let i = 0; i < notificationsNew.length; i += 1) {
      updateAllNotification(notificationsNew[i].providerRut, notificationsNew[i].orderId, notificationsNew[i].invoiceId);
    }

    // Refresh notification status
    getNotifications(user.rut);

    // Close menu
    const { showMenu } = this.state;
    this.setState({ showMenu: !showMenu });
  };

  render() {

    const {
      name,
      isAdmin,
      onLogoutClick,
      notifications,
      notificationsNew,
      hasAutomatedPayments
    } = this.props;

    const { 
      showMenu,
      showUserMenu
    } = this.state;

    return (
      <NavBarWrapper>
        <ImpersonatingFlag />
        <div className="navbar__container">
          <div className="navbar__links">

            {isAdmin && (
              <div className="d-flex align-items-center">
                <h1 style={{ color: 'var(--text-color-2)' }}>
                  Administrador
                </h1>

                <NavLink
                  to="/admin/ordenes"
                  activeClassName="active-page"
                >
                  Órdenes
                </NavLink>

                <NavLink
                  to="/admin/pagos"
                  activeClassName="active-page"
                >
                  Pagos
                </NavLink>
                <NavLink
                  to="/admin/impersonate"
                  activeClassName="active-page"
                >
                  Impersonar un Proveedor
                </NavLink>
              </div>
            )}

            {!isAdmin && (
              <div className="d-flex align-items-center navbar__grid">
                <h1 style={{ color: 'var(--text-color-2)' }}>
                  Facturación de Siniestros - Proveedor
                </h1>

                <div>
                  <NavLink
                    to="/ordenes"
                    activeClassName="active-page"
                  >
                    Órdenes
                  </NavLink>

                  <NavLink
                    to="/estado-cuenta"
                    activeClassName="active-page"
                  >
                    Estado de cuenta
                  </NavLink>
                  {hasAutomatedPayments && <NavLink
                    to="/importar"
                    activeClassName="active-page"
                  >
                    Solicitar Pago
                  </NavLink>}

                </div>
              </div>
            )}
          </div>

          <div className="navbar__right-section">

            <div className="navbar__notiWrapper">
              { notifications && 
                notifications.length > 0 && (
                  <button type="button" className="navbar__button navbar__button--reset" onClick={(e) => this.onNotificationsClick(e)}>
                    <img className="iconNoti" alt={name} src={iconNoti} />
                    {notificationsNew.length > 0 && <div className="alert"> {notificationsNew.length} </div>}
                  </button>
                )
              }

              { notifications && notifications.length > 0 && (
                <Menu show={showMenu} close={() => {this.setState({showMenu: false})}}>
                  { notifications.map((notification, i) => {
                    return (
                      <NotificationItem
                        key={i}
                        comment={notification.paymentComment.length > 0 ? notification.paymentComment : "Sin comentarios"}
                        date={notification.date.substring(0, 10)}
                        orderId={notification.orderId}
                        isRead={notification.isRead}
                        onClick={() => this.onNotificationItemClick(i)} 
                      /> 
                    )
                  })}

                  { notificationsNew.length > 0 && (
                    <NotificationItem
                      key={100}
                      comment="Marcar todas como leidas"
                      date=""
                      orderId={null}
                      isRead
                      onClick={() => this.onAllNotificationItemClick()}
                      hideData
                    />
                    )}
                </Menu>
              )}
            </div>

            <div>
              <div 
                role="button" 
                tabIndex={0}
                onKeyPress={(e) => this.onUserNameClick(e)} 
                onClick={(e) => this.onUserNameClick(e)} 
                className='dropdown-button'
              >
                <img className="iconUser" alt={name} src={iconUser} />
                {name}
              </div>
              <div className={`dropdown-content ${showUserMenu ? 'dropdown-show' : ''}`}>
                <Link 
                  to={{
                    pathname: "/cambio-contraseña",
                    state: { modal: true },
                  }}
                >
                  Cambiar contraseña
                </Link>
              </div>
            </div>
            <span> | </span>
            <Link
              to="/login"
              onClick={onLogoutClick}
            >
              Salir
            </Link>
          </div>
        </div>
      </NavBarWrapper>
    );
  }
}

const mapStateToProps = state => ({
  isLoading: state.auth.isLoading,
  user: state.auth.user,
  notifications: state.invoice.notifications,
  notificationsNew: state.invoice.notificationsNew,
});

const mapDispatchToProps = {
  getNotifications: (providerRut) => invoiceActions.getNotifications({ providerRut }),
  updateNotification: (providerRut, orderId, invoiceNumber) => invoiceActions.updateNotification({ providerRut, orderId, invoiceNumber }),
  updateAllNotification: (providerRut, orderId, invoiceNumber) => invoiceActions.updateAllNotification({ providerRut, orderId, invoiceNumber }),
};

export default connect(mapStateToProps, mapDispatchToProps)(NavBar);
